module.exports = __webpack_public_path__ + "assets/img/btn-detail-7be05a52.png";